export default __webpack_public_path__ + "static/media/win-2k-server.24478d32.png";